import { render, staticRenderFns } from "./unread-notice.vue?vue&type=template&id=43b0a7f1&scoped=true&"
import script from "./unread-notice.vue?vue&type=script&lang=js&"
export * from "./unread-notice.vue?vue&type=script&lang=js&"
import style0 from "./unread-notice.vue?vue&type=style&index=0&lang=less&"
import style1 from "./unread-notice.vue?vue&type=style&index=1&id=43b0a7f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b0a7f1",
  null
  
)

export default component.exports